import { AloMission } from '@/models/alo/AloMission';
import {zoomIdentity, ZoomTransform} from 'd3'
import { dataLimitMode, GraphUiState } from './GraphUiState';
export class HoverData extends GraphUiState {
    
            
    public pointerX:number
    public pointerY:number
    public hover:boolean
    public sciGraph:boolean
    public simuGraph:boolean
    
    constructor({        
                pointerX=0,
                pointerY=0,
                hover=true,
                sciGraph=true,
                simuGraph=false
            } = {}) { 

        super(...arguments)
        this.pointerX = pointerX
        this.pointerY = pointerY
        this.hover = hover
        this.sciGraph = sciGraph
        this.simuGraph = simuGraph
        this.variableX = ""
        this.variableY = ""
    }
} 